module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-hh.be3f6743.png";